// GENERATED FILE - DO NOT MODIFY
export enum ServiceCallContractQuotationFormType {
    CustomerDetailed = "5",
    CustomerSummary = "6",
    InternalUse = "7",
}

export let nameof = "ServiceCallContractQuotationFormType";
